<hw-page-header header="term.di-05.header" class="page-header" (onBack)="goBack()">
  <div class="content float-right">
    <button (click)="form.valid && save()" class="float-right" nz-button nzType="primary">
      {{ 'core.btn.save' | translate }}
    </button>
  </div>
</hw-page-header>

<nz-content class="main" *ngIf="concept && dictionary">
  <form nz-form #form="ngForm">
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="code" [required]="true" label="term.di-05.id">
          <input nz-input name="code" [(ngModel)]="concept.code" required />
        </hw-form-item>
      </div>
    </hw-form-row>
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="names" label="term.di-05.names">
          <hw-multilang-input name="names" [(ngModel)]="concept.names"></hw-multilang-input>
        </hw-form-item>
      </div>
    </hw-form-row>
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="parent" label="term.di-05.parent">
          <hw-term-dictionary-concept-select
            name="parent"
            [(ngModel)]="concept.parent"
            [dictionary]="dictionary.id"
            [exclude]="concept.code"></hw-term-dictionary-concept-select>
        </hw-form-item>
      </div>
    </hw-form-row>

    <nz-divider nzText="{{ 'term.di-05.attributes' | translate }}" nzOrientation="left"></nz-divider>
    <hw-form-row *ngFor="let attr of dictionary.attributes">
      <div *hw-form-col>
        <hw-form-item [name]="attr.id" label="{{ attr.names | localName : attr.id }}">
          <hw-term-attribute-input
            [name]="attr.id"
            [(ngModel)]="concept.attributes[attr.id]"
            [attribute]="attr"></hw-term-attribute-input>
        </hw-form-item>
      </div>
    </hw-form-row>
  </form>
</nz-content>
